import React, { useState, useEffect } from 'react' 
import LoginBanner from '../images/loginbg.png';
import Row from "react-bootstrap/Row";
import OtpInput from "react-otp-input";
import { NavLink, useNavigate } from "react-router-dom";
import LangSwitcher from './common/LanguageSwitcher';
import { useTranslation } from "react-i18next";
import axios from "axios";
import swal from "sweetalert";


export default function OtpVerification() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [otp, setOTP] = useState('');
  const [valid, setValid] = useState(true);
  
  var OTP_COUNTER= localStorage.getItem("otpCounter") == null ? 59 : localStorage.getItem("otpCounter")
  const [counter, setCounter] = React.useState(OTP_COUNTER);
  
  React.useEffect(() => {
    if(localStorage.getItem("USERLOGIN") == 'YES') {
      navigate("/features");
    }
    const timer =
    counter > 0 && setInterval(() => {
      localStorage.setItem("otpCounter", counter);
      setCounter(counter - 1)
      console.log("COUNT: ", counter);
    }, 1000);
    return () => clearInterval(timer);
  }, [counter]);

  
  const handleChange = (otp) => {
    setOTP(otp);
    if(otp.length == 6) {
      setValid(false);
    } else {
      setValid(true);
    }
    
   // console.log('SDSDSSD: '+otp.length+ ' <> '+otp );

  }
  
  const userData = localStorage.getItem("userData") == null ? false : localStorage.getItem("userData");
  
  if(userData == 'undefined' || !userData) {
    navigate('/');
  }
  const submitFrom = (e) =>{
    if(userData == 'undefined') {
      navigate('/');
    }
    console.log('DDDDD: ', otp);
    const otpData = { otp: otp, user_data: userData };
      axios.post(process.env.REACT_APP_API_KEY+"api/otp-validate",otpData, {headers: {
        "Content-type": "Application/json",
        "sellang": localStorage.getItem("selectLang")
        }   
        }).then((res)=>{
        if (res.data.status == true) {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("fname", res.data.fname);
          localStorage.setItem("lname", res.data.lname);
          localStorage.setItem("nameImage", res.data.UserUimage);
          localStorage.setItem("USERLOGIN", 'YES');
          localStorage.removeItem("otpCounter")
          navigate("/features");
        } else {
          swal("Oops", "Invalid otp please enter a valid otp.", "error");
        }
          console.log('EEEEE:', res.data.status);
      }).catch(error => {
        swal("Oops", "Invalid otp please enter a valid otp.", "error");
        //swal("Oops", error.message, "error");
      console.log('aya',error);
      })
  }

  const resendSendOtp = (e) => {
    e.preventDefault()
    console.log('resendSendOtp');

    const resendOtpData = {user_data: userData };
    axios.post(process.env.REACT_APP_API_KEY+"api/otp-resend",resendOtpData, {headers: {
      "Content-type": "Application/json",
      "sellang": localStorage.getItem("selectLang")
      }   
      }).then((res)=>{
      if (res.data.status == true) {
        //localStorage.setItem("otpCounter", 59);
        setCounter(59);
        //swal("Oops", "Your OTP has been sent sent Successfully. Please try again again.", "success");
        swal("", res.data.message, "success");
      } else {
        swal("Oops", "Something went wrong please try again.", "error");
      }
      console.log('EEEEE:', res.data);
    }).catch(error => {
      swal("Oops", "Unauthorized User", "error");      
      console.log('ayass',error);
    });

  }
  const backAction = () => {
    navigate("/");
  }

  return (
    <>
    <div className="Otp">
        <div className="login">
        <div className="d-flex flex-column-reverse flex-md-row">
            <div className="w-100 w-md-40">
              <div className="login-form-container">
                <div className="contact01 position-relative main-left-form">
                  <div className="login-head">
                  <LangSwitcher/>
                  </div>
                  <div className="login-form-head">
                    <div className="form-heading">
                      <h3>{t('otp_heading1')}</h3>
                      <p>{t('otp_heading2')}</p>
                    </div>
                  </div>
                  <div className="login-form">
                    <div className="main-form m-0">
                      <div>
                        <form>
                          <div className="mb-3">
                            <OtpInput name="txtotp"
                              value={otp}
                              numInputs={6}
                              onChange={handleChange}
                              separator={<span>-</span>}
                              
                            />
                        
                          </div>
                          <div className="resendotp">
                          {counter > 1 ? <div className= "counter-resed">Resend OTP in: {counter}</div> : <div className= "linl-resed"><a onClick={resendSendOtp} href="">{t('otp_resend')}</a></div> }
                            
                          </div>
                          <div className="login-btn-box d-flex">
                          <button type="button" onClick={backAction} className="btn btn-red-bg btn-md nav-btn fill back-btn">{t('reset_button_back')}</button>
                            <button type="button" disabled={valid} onClick={submitFrom} className="btn btn-red-bg btn-md">
                              {t('otp_button')}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-100 w-md-60">
              <div className="right-box">
                <img src={LoginBanner} alt="" className="img-fluid login-bg" />
                <div className="banner-text px-4">
                  <div>
                    <p id="welcome">{t('forgot_welcome')}</p>
                    <p>{t('forgot_msg')}</p>
                    <div id="line"></div>
                    <span>{t('forgot_line_msg')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}